import React from 'react'
import CardsUSP from '/react4xp/components/CardsUSP'
import MarqueeSlider from '/react4xp/components/MarqueeSlider'
import EntryCard from '/react4xp/components/EntryCard'

interface PartnershipsProps {
   main: {
      title: string,
      intro?: string,
      img: {
         srcMobile: string,
         src: string,
         alt: string,
      },
      cards?: {
         title: string,
         content?: string,
      }[],
      cta?: {
         label: string,
         url: string,
         isExternal?: boolean,
      },
      color?: string,
   },
   sliderItems?: {
      src: string,
      alt: string,
   }[],
   partnersTitle?: string,
   successStories: {
      tag?: string,
      title: string,
      quote?: {
         text: string,
         author?: string,
         position?: string,
      },
      cta?: {
         label: string,
         url: string,
         isExternal?: boolean,
      },
      img?: {
         srcMobile: string,
         src: string,
         alt: string,
      },
      orientation?: string,
   }
   color?: string,
}

export default function Partnerships(props: PartnershipsProps) {
   const { main, successStories, sliderItems, partnersTitle, color } = props;

   return (
      <div className="partnerships">
         <div className="partnerships__wrapper">
            <CardsUSP
               title={main.title}
               intro={main.intro}
               img={main.img}
               cards={main.cards}
               cta={main.cta}
               color={color}
            />
            {sliderItems?.length ? <MarqueeSlider
               title={partnersTitle}
               sliderItems={sliderItems}
               color={color}
            /> : <></>}
            <EntryCard
               tag={successStories.tag}
               title={successStories.title}
               content={successStories.quote}
               cta={successStories.cta}
               img={successStories.img}
               orientation={successStories.orientation}
               contentColor={color}
            />
         </div>
      </div>
   )
}